var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    height: "48px",
    width: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40.7,22.63c-3.34,0-6.06,2.72-6.06,6.06c0,2.44,1.43,4.59,3.62,5.54c-0.01,1.57-0.08,2.96-0.69,4.34 c-0.99,2.26-3.45,3.72-6.27,3.72c-0.41,0-0.82-0.03-1.22-0.1c-1.75-0.29-2.96-1.46-4.36-2.83c-1.63-1.58-3.48-3.38-6.4-3.67 c-1.55-0.16-3.27-0.23-5.25-0.23c-1.75,0-3.53,0.06-5.24,0.11c-1.58,0.05-3.37,0.11-5.05,0.11c-1.35,0-2.41,1.07-2.41,2.44 s1.06,2.44,2.41,2.44h9.17c0.54,0,1.07-0.01,1.62-0.02l0.12,0c0.43-0.01,0.86-0.02,1.27-0.02c2.71,0,4.43,0.34,6.26,2.2 c2.89,2.92,6.04,4.4,9.37,4.4c1.65,0,3.34-0.37,5.03-1.11c4.16-1.82,6.35-5.79,6.51-11.78c2.2-0.95,3.63-3.11,3.63-5.55 C46.75,25.35,44.04,22.63,40.7,22.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.86,0.87H4.99c-1.5,0-2.72,1.22-2.72,2.72v4.54c0,0.68,0.55,1.22,1.22,1.22H4.7c0.68,0,1.22-0.55,1.22-1.22 V5.11c0-0.32,0.26-0.58,0.58-0.58h10.82c0.32,0,0.58,0.26,0.58,0.58l0.02,6.76H3.5c-0.68,0-1.22,0.55-1.22,1.22v16.08 c0,0.68,0.55,1.22,1.22,1.22h16.85c0.68,0,1.22-0.55,1.22-1.22V3.59C21.57,2.09,20.36,0.87,18.86,0.87z M11.1,18.92 c-0.21-0.24-0.3-0.55-0.25-0.87c0.07-0.44,0.43-0.82,0.87-0.9c0.07-0.01,0.14-0.02,0.2-0.02c0.6,0,1.09,0.49,1.09,1.09 c0,0.33-0.14,0.56-0.26,0.7c-0.26,0.3-0.41,0.69-0.41,1.07v2.06c0,0.12-0.1,0.22-0.22,0.22h-0.4c-0.12,0-0.22-0.1-0.22-0.22v-2.06 C11.51,19.6,11.36,19.22,11.1,18.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg47);
export default __webpack_public_path__ + "static/media/47.aeb2529af7c29b43d7a86e0eb652c217.svg";
export { ForwardRef as ReactComponent };